import $ from 'jquery';

if ($('.accordion .title').length) {
  // On load sets first accordion to open
  $(document).ready(function () {
    $('.accordion')[0].classList.add('open');
    let defaultHeight = $('.text-content').eq(0).prop('scrollHeight');
    $('.text-content').eq(0).css('max-height', defaultHeight);
  });

  $(function () {
    $('.accordion .title').on('click', function (e) {
      e.preventDefault();

      let $this = $(this);
      let $accordion = $this.parent();
      let $content = $this.next();

      // This will minimize everything
      // $accordion.parent().find('.text-content').css('max-height', '0');

      if ($accordion.hasClass('open')) {
        $accordion.removeClass('open');
        $accordion.find('.text-content').css('max-height', '0');
      } else {
        $accordion.addClass('open');
        $content.css('max-height', $content[0].scrollHeight);
      }
    });
  })

  $(window).on('resize', function () {
    $('.accordion.open .text-content').css('max-height', '0');
    $('.accordion.open').removeClass('open');
  })
}
